import type { IRestrictionListingMessages } from '.';

const restrictionListingMessages: IRestrictionListingMessages = {
	actions: 'Actions',
	add: 'Add',
	delete: 'Remove',
	deleteSelected: 'Remove selected',
	createRestriction: 'Create Restriction',
	deleteRestriction: 'Remove Restriction',
	modalHead: 'Removing ',
	modalHeadSelect: 'Removing multiple restrictions',
	modalBody:
		'You cannot undo this action. Are you sure you want to remove this restriction?',
	modalBodySelect:
		'You cannot undo this action. Are you sure you want to remove these restrictions?',
	restrictionHeader: 'Restrictions',
	restrictionMessage: 'Restriction Message',
	supplier: 'Supplier',
	productNumber: 'Item Number',
	umCodes: 'Unit of Measure',
	heading: 'Restrictions',
	locationCount:
		'{locationCount, number} {locationCount, plural, one {Location} other {Locations}}',
	productCount:
		'{productCount, number} {productCount, plural, one {Item} other {Items}}',
	categoryCount:
		'{categoryCount, number} {categoryCount, plural, one {Category} other {Categories}}',
	restricted: 'Restricted',
	unrestricted: 'Unrestricted',
	categoryRestrictionMessage: 'Message to Purchaser',
};

export default restrictionListingMessages;
